import { render, staticRenderFns } from "./NhlFullStats.vue?vue&type=template&id=751b08fa&scoped=true"
import script from "./NhlFullStats.vue?vue&type=script&lang=js"
export * from "./NhlFullStats.vue?vue&type=script&lang=js"
import style0 from "./NhlFullStats.vue?vue&type=style&index=0&id=751b08fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751b08fa",
  null
  
)

export default component.exports